import(/* webpackMode: "eager" */ "/codebuild/output/src1537574305/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/cgv-snapshot/cgv-snapshot.css");
;
import(/* webpackMode: "eager", webpackExports: ["CgvSnapshotClient"] */ "/codebuild/output/src1537574305/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/cgv-snapshot/CgvSnapshotClient.tsx");
